const fetchDataStateEnum = {
    pending: "pending",
    fulfilled: "fulfilled",
    rejected: "rejected",
};

export const changePage = "changePage";
export const hasMoreData = "hasMoreData";

export default fetchDataStateEnum;
